import SearchOwner from './searchOwner';

export default SearchOwner;
